import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import _ from 'underscore';

class Component extends BaseComponent {
    componentDidMount() {
        if (!this.props.nodes && this.props.tag != 'psychics') {
            this.props.requireContent(this.props.tag);
        }
    }

    /* eslint-disable max-len */
    render({ header, nodes, url, tag }) {
        if (_.isArray(nodes) && !_.isEmpty(nodes)) {
            return (
                <nav-articles tag={tag}>
                    <a href={url} onClick={() => this.trackClick(`${this.props.category} - ${header}`)}>{header}</a>
                    <ul>{nodes.map(this.renderNode)}</ul>
                </nav-articles>
            );
        } else if (tag == 'psychics') {

            return (
                <nav-articles tag={tag}>
                    <row className='is-wrap is-justified-around'>
                        <column className='is-4 is-12-tablet-portrait is-12-mobile'>
                            <promo-message placement='psychic-nav-article' tags='one' />
                        </column>
                        <column className='is-4 is-12-tablet-portrait is-12-mobile'>
                            <promo-message placement='psychic-nav-article' tags='two' />
                        </column>
                    </row>
                </nav-articles>
            );
        }

        return (<nav-articles tag={tag} />);
    }
    /* eslint-enable max-len */

    renderNode = (node, i) => {
        const image_src = node.picture_frag
            ? `https://gfx.tarot.com/images/feeds/380x235/${node.picture_frag}-380x235.jpg`
            : '';

        return (
            <li>
                <a
                    href={node.url}
                    onClick={() => this.trackClick(`${this.props.category} - Featured Article #${i + 1}`)}
                >
                    <row className='is-wrap'>
                        <column className='is-3 is-12-tablet-portrait is-12-mobile'>
                            <img src={image_src} alt={node.image_alt} />
                        </column>
                        <column className='is-9 is-12-tablet-portrait is-12-mobile'>
                            <p className='article-title'>{node.title}</p>
                            <p>{node.subtitle}<span> … Read More</span></p>
                        </column>
                    </row>
                </a>
            </li>
        );
    }

    trackClick = (label) => {
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';

        this.props.trackEvent(['Navigation', action, label]);
    }
}

const mapStateToProps = (state, { tag }) => ({
    nodes: state.content && state.content.nav && state.content.nav[tag],
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    requireContent: (tag) => dispatch({ type: 'content:fetchNav', payload: tag }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
